import axios from 'axios';
import {CLEAR_A_TOWJOB_ERROR_MESSAGE, clearTowErrorMsgInStore} from "../towjob/actions";
import AppUtils from "../../../utils/AppUtils";
import {loadFaxDataInStore} from "../fax/actions";


export const LOAD_COMPANYPROPERTY_DATA = 'companyproperty/LOAD_COMPANYPROPERTY_DATA';
export const DELETE_A_COMPANYPROPERTY = 'companyproperty/DELETE_A_COMPANYPROPERTY';
export const SAVE_A_COMPANYPROPERTY = 'companyproperty/SAVE_A_COMPANYPROPERTY';
export const UPDATE_A_COMPANYPROPERTY = 'companyproperty/UPDATE_A_COMPANYPROPERTY';
export const CLEAR_A_COMPANYPROPERTY_ERROR_MESSAGE = 'companyproperty/CLEAR_A_COMPANYPROPERTY_ERROR_MESSAGE';


export function clearCompanyPropertyErrorMsgInStore() {
	return {
		type: CLEAR_A_COMPANYPROPERTY_ERROR_MESSAGE,
		
	}
}

export function loadCompanypropertyDataInStore(argCompanypropertyDataArray) {
	return {
		type: LOAD_COMPANYPROPERTY_DATA,
		companypropertysData: argCompanypropertyDataArray
	}
}

export function deleteACompanypropertyInStore(argDeleteResponse, argErrorMsg) {
	return {
		type: DELETE_A_COMPANYPROPERTY,
		deleteCompanypropertyResponse: argDeleteResponse,
		errorMsg: argErrorMsg
	}
}

export function saveACompanypropertyDataInStore(argSaveResponse, argErrorMsg) {
	return {
		type: SAVE_A_COMPANYPROPERTY,
		saveCompanypropertyResponse: argSaveResponse,
		errorMsg: argErrorMsg
	}
}

export function updateACompanypropertyDataInStore(argSaveResponse, argErrorMsg) {
	return {
		type: UPDATE_A_COMPANYPROPERTY,
		updateCompanypropertyResponse: argSaveResponse,
		errorMsg: argErrorMsg
	}
}

/********************* End of InStore calls **************************/



export function addCompanyPropertyToCompanyPropertysArray(argFax ) {
	console.log("Farshid addCompanyPropertyToCompanyPropertysArray is called in action");
	return (dispatch, getState) => {
		const state = getState();
		let tempFaxsArray=[] ;
		tempFaxsArray = Object.assign(tempFaxsArray,state.companyproperty.companypropertysArray);
		//first remove the item if it's in the list
		let newStorageArray = tempFaxsArray.filter(element => { return element.id !== argFax.id });
		//adding to the top of the array.
		newStorageArray.unshift(argFax);
		//tempTowJobsArray.concat(argTowJob);
		dispatch(loadCompanypropertyDataInStore(newStorageArray));
	}//end of return
}


export function deleteCompanyPropertyFromCompanyPropertysArray(argFaxId ) {
	return (dispatch, getState) => {
		const state = getState();
		let tempFaxsArray=[] ;
		tempFaxsArray = Object.assign(tempFaxsArray,state.companyproperty.companypropertysArray);
		//removig the match element with the matching id.
		let newArray = tempFaxsArray.filter(element => { return element.id != argFaxId });
		//tempTowJobsArray.concat(argTowJob);
		dispatch(loadCompanypropertyDataInStore(newArray));
	}//end of return
}

export function updateCompanyPropertyInCompanyPropertysArray(argFAx ) {
	return (dispatch, getState) => {
		const state = getState();
		let tempFaxsArray=[] ;
		tempFaxsArray = Object.assign(tempFaxsArray,state.companyproperty.companypropertysArray);
		//rempoving the item from the array and then add the updated one to the array array.
		let newArray = tempFaxsArray.filter(element => { return element.id != argFAx.id });
		//adding to the top of the array.
		newArray.unshift(argFAx);
		//tempTowJobsArray.concat(argTowJob);
		dispatch(loadCompanypropertyDataInStore(newArray));
	}//end of return
}




//****************************************
//Below is for update a Stream
//****************************************
export function clearCompanyPropertyErrorMsg() {
	return (dispatch, getState) => {
		dispatch(clearCompanyPropertyErrorMsgInStore());
	}
}

export function updateACompanyproperty(argURL, argCamera, argCompanyId) {
	return (dispatch, getState) => {
		const state = getState();
		updateACompanypropertyOnServer(argURL, argCamera, argCompanyId, state.login.loginData.idToken, state.user.saveUserResp.id).then(function (saveResponse) {
			
			dispatch(updateACompanypropertyDataInStore(saveResponse.data, {
				"status": saveResponse.status,
				"statusText": saveResponse.statusText
			}));
			dispatch(loadCompanypropertysData(argURL,  argCompanyId));
			
		}, function (err) {
			var errorObj = AppUtils.getErroStatusAndText(err);
			console.log("I had an error updating a company-property" + errorObj.statusText + errorObj.status);
			dispatch(updateACompanypropertyDataInStore({}, errorObj));
		});
	}//end of return
}


function updateACompanypropertyOnServer(argURL, argCamera, argCompanyId, argIdToken, argUserId) {
	
	var returnPromise = new Promise(function (resolve, reject) {
		
		if ((argURL != null) || (argURL.length != 0)) {
			axios.all(getArrayOfPutsForUpdateACompanyproperty(argURL, argCamera, argCompanyId, argIdToken, argUserId)).then(function (responses) {
				resolve(responses[0]);
			}, function (err) {
				//console.log("Farshid some error occured on saving a StorageLot " + err.message +  " the URL is " + argURL );
				reject(err);
			});
		}
	});
	
	return returnPromise;
}


function getArrayOfPutsForUpdateACompanyproperty(argURL, argCompanyproperty, argCompanyId, argIdToken, argUserId) {
	/*
	 I build something like this :
	 http://localhost:4567/companys
	 */
	
	let baseUrl = argURL + "users/" + argUserId + "/companies/" + argCompanyId + "/property";
	console.log(" on posting a companyproperty the URL is " + baseUrl);
	
	var arrayOfGets = [];
	if (argURL != null) {
		arrayOfGets.push(axios.put(baseUrl, argCompanyproperty, {headers: {"Authorization": `Bearer ${argIdToken}`}}));
	}
	return arrayOfGets;
}


//****************************************
//Below is for save a Stream
//****************************************
export function saveACompanyproperty(argURL, argCamera, argCompanyId) {
	return (dispatch, getState) => {
		const state = getState();
		saveACompanypropertyOnServer(argURL, argCamera, argCompanyId, state.login.loginData.idToken, state.user.saveUserResp.id).then(function (saveResponse) {
			
			dispatch(saveACompanypropertyDataInStore(saveResponse.data, {
				"status": saveResponse.status,
				"statusText": saveResponse.statusText
			}));
			dispatch(loadCompanypropertysData(argURL,  argCompanyId));
			
		}, function (err) {
			var errorObj = AppUtils.getErroStatusAndText(err);
			console.log("I had an error saving a Company Property" + errorObj.statusText + errorObj.status);
			dispatch(saveACompanypropertyDataInStore({}, errorObj));
		});
	}//end of return
}


function saveACompanypropertyOnServer(argURL, argCamera, argCompanyId, argIdToken, argUserId) {
	
	var returnPromise = new Promise(function (resolve, reject) {
		
		if ((argURL != null) || (argURL.length != 0)) {
			axios.all(getArrayOfPostsForSaveACompanyproperty(argURL, argCamera, argCompanyId, argIdToken, argUserId)).then(function (responses) {
				resolve(responses[0]);
			}, function (err) {
				//console.log("Farshid some error occured on saving a companyproperty " + err.message +  " the URL is " + argURL );
				reject(err);
			});
		}
	});
	
	return returnPromise;
}


function getArrayOfPostsForSaveACompanyproperty(argURL, argCamera, argCompanyId, argIdToken, argUserId) {
	/*
	 I build something like this :
	 http://localhost:4567/companys
	 */
	
	let baseUrl = argURL + "users/" + argUserId + "/companies/" + argCompanyId + "/property";
	console.log(" on posting a companyproperty the URL is " + baseUrl);
	
	var arrayOfGets = [];
	if (argURL != null) {
		arrayOfGets.push(axios.post(baseUrl, argCamera, {headers: {"Authorization": `Bearer ${argIdToken}`}}));
	}
	return arrayOfGets;
}


//****************************************
//Below is for delete a company
//****************************************
export function deleteACompanyproperty(argURL, argCameraId, argCompanyId) {
	return (dispatch, getState) => {
		const state = getState();
		deleteACompanypropertyOnServer(argURL, argCameraId, argCompanyId, state.login.loginData.idToken, state.user.saveUserResp.id).then(function (deleteResponse) {
			
			dispatch(deleteACompanypropertyInStore(deleteResponse.data, {
				"status": deleteResponse.status,
				"statusText": deleteResponse.statusText
			}));
			dispatch(loadCompanypropertysData(argURL,  argCompanyId));
			
		}, function (err) {
			var errorObj = AppUtils.getErroStatusAndText(err);
			console.log("I had an error deleting a company property " + errorObj.statusText + errorObj.status);
			dispatch(deleteACompanypropertyInStore({}, errorObj));
		});
	}//end of return
}


function deleteACompanypropertyOnServer(argURL, argStreamId, argCompanyId, argIdToken, argUserId) {
	
	var returnPromise = new Promise(function (resolve, reject) {
		
		
		if ((argURL != null) || (argURL.length != 0)) {
			axios.all(getArrayOfDeletesForDeleteACompanyproperty(argURL, argStreamId, argCompanyId, argIdToken, argUserId)).then(function (responses) {
				resolve(responses[0]);
			}, function (err) {
				//console.log("Farshid some error occured on deleteing a Companyproperty " + err.message +  " the URL is " + argURL );
				reject(err);
			});
		}
	});
	
	return returnPromise;
}


function getArrayOfDeletesForDeleteACompanyproperty(argURL, argStreamId, argCompanyId, argIdToken, argUserId) {
	/*
	 I build something like this :
	 http://localhost:4567/cameras
	 */
	
	let baseUrl = argURL + "users/" + argUserId + "/companies" + "/" + argCompanyId + "/property/" + argStreamId;
	console.log(" on deleteing a Companyproperty the URL is " + baseUrl);
	
	var arrayOfGets = [];
	if (argURL != null) {
		arrayOfGets.push(axios.delete(baseUrl, {headers: {"Authorization": `Bearer ${argIdToken}`}}));
	}
	return arrayOfGets;
}


//Get list of companys

export function loadCompanypropertysData(argURL, argCompanyId) {
	if((argCompanyId !== null) && ( argCompanyId !== undefined)) {
		return (dispatch, getState) => {
			const state = getState();
			getListOfCompanypropertys(argURL, argCompanyId, state.login.loginData.idToken, state.user.saveUserResp.id).then(function (companysList) {
				
				dispatch(loadCompanypropertyDataInStore(companysList));
				
			}, function (err) {
				console.log("I had an error gettting Farms Data2" + err);
			});
		}//end of return
	}
}

function getArrayOfGetsForListOfCompanypropertys(argURL, argCompanyId, argIdToken, argUserId) {
	/*
	 I build something like this :
	 http://localhost:4567/company
	 */
	
	let baseUrl = argURL + "users/" + argUserId + "/companies/" + argCompanyId + "/property";
	console.log(" on getting list of Companypropertys  the URL is " + baseUrl);
	
	var arrayOfGets = [];
	if (argURL != null) {
		arrayOfGets.push(axios.get(baseUrl, {headers: {"Authorization": `Bearer ${argIdToken}`}}));
	}
	return arrayOfGets;
}

function getListOfCompanypropertys(argURL, argCompanyId, argIdToken, argUserId) {
	
	var returnPromise = new Promise(function (resolve, reject) {
		
		var arrayOfGets = [];
		
		if ((argURL != null) || (argURL.length != 0)) {
			axios.all(getArrayOfGetsForListOfCompanypropertys(argURL, argCompanyId, argIdToken, argUserId)).then(function (responses) {
				resolve(responses[0].data);
			}, function (err) {
				console.log("Farshid some error occurred on getting list of companys property" + err.message + " the URL is " + argURL);
				reject(err);
			});
		}
	});
	
	return returnPromise;
}

/*
function getCompanypropertysDataFromRemoteServer( argURL, argCompanysList  ){

    var returnPromise = new Promise(function(resolve, reject){

        var arrayOfGets = [];

        if(argCompanysList != null){

            axios.all(getArrayOfGets(argURL, argCompanysList )).then(function(responses){
                resolve(responses);

            }, function(err) {
                console.log("Farshid some error occured " + err.message);
                reject(err);
            });
        }
    });

    return returnPromise;
}

*/

/*
function getArrayOfGets(argURL, argFarmsList ){

    //let baseUrl =  "http://innovasea-app-dev-1.eastus.cloudapp.azure.com:4567/METRIC_VALUES?";
    let baseUrl = argURL;



    var arrayOfGets = [];
    if(argFarmsList != null) {
        for (var i = 0; i < argFarmsList.length; i++) {
                let responseData = argFarmsList[i];
                //let responseData = singleResponse.data;
                //if((argMetricList[i].checked != null) && (argMetricList[i].checked == true) ) {
                let tempURl = baseUrl + "GRAPHS" + "/farm_summary?farmId=" + responseData.id;
                console.log("Farshid the Company DATA URL is =" + tempURl);
                arrayOfGets.push(axios.get(tempURl));

            //}
        }
    }
    return arrayOfGets;


}

*/

/*
export function loadCompanyData(argURL) {
    return (dispatch, getState) => {


        var arrayOfCompanyData=[];
        getListOfCompanys(argURL).then(function(companysList){

            for(var z=0; z<companysList.length; z++){

                let singleResponse = companysList[z];
                let responseData = singleResponse.data;
                getCompanyDataFromRemoteServer(argURL,responseData ).then(function (farmsData){
                    for(var i=0; i<farmsData.length; i++) {
                        arrayOfCompanyData.push(farmsData[i].data);
                    }
                    dispatch(loadCompanyDataInStore(arrayOfCompanyData));

                }, function (err){
                    console.log("I had an error gettting Farms Data3333" + err);
                });

            }
    }, function(err){
        console.log("I had an error gettting Farms Data2" + err);
        });
    }//end of return
}
 */
